export default "__VITE_ASSET__CFfkdPgW__"